import { AppColors } from '@cmbg-traky-web/design-system';
import { CSSProperties } from 'react';

type FiltersPanelStyles = {
  filtersPanel: CSSProperties;
  filtersPanelTablet: CSSProperties;
  topBar: CSSProperties;
  topBarTablet: CSSProperties;
  topBarMobile: CSSProperties;
  quickFilters: CSSProperties;
  quickFilters__label: CSSProperties;
  quickFilters__checkboxGroup: CSSProperties;
  filtersPanel__tags: CSSProperties;
  filtersPanel__tagsTablet: CSSProperties;
  searchbar: CSSProperties;
  searchbarTablet: CSSProperties;
};

const styles: FiltersPanelStyles = {
  filtersPanel: {
    position: 'relative',
    backgroundColor: AppColors.VA.NEUTRALS.WHITE,
    borderRadius: '8px'
  },
  filtersPanelTablet: {
    position: 'relative',
    backgroundColor: AppColors.VA.NEUTRALS.WHITE,
    borderRadius: '8px'
  },
  topBar: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
    marginBottom: '16px',
    flexWrap: 'wrap'
  },
  topBarTablet: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    marginBottom: '12px',
    flexWrap: 'nowrap',
    justifyContent: 'space-between'
  },
  topBarMobile: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px',
    flexWrap: 'nowrap',
    justifyContent: 'space-between'
  },
  quickFilters: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: 16,
    gap: 8
  },
  quickFilters__label: {
    fontWeight: 600,
    color: AppColors.VA.NEUTRALS._90_
  },
  quickFilters__checkboxGroup: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    borderRadius: '2px'
  },
  filtersPanel__tags: {
    display: 'flex',
    gap: '8px',
    marginBottom: '16px',
    flexWrap: 'wrap'
  },
  filtersPanel__tagsTablet: {
    display: 'flex',
    gap: '6px',
    marginBottom: '12px',
    flexWrap: 'wrap'
  },
  searchbar: {
    width: '100%'
  },
  searchbarTablet: {
    width: '100%'
  }
};

export default styles;
